import { UIStatusUpdate } from '../types/context-types'

export const initialUIStatus = { id: 1, 
    currentDisplay: 'bezier',
    bezierDisplayValue: [.25, 0, .75, 1], 
    initializationTime: Date.now() } as UIStatusUpdate
